import React, { Fragment } from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

const translate = trKey => window.VULOG_TRANSLATE(trKey);

function CardSection({ onCardChange, setPostalCode }) {
    const hidePostalCode = window.VULOG_CONFIG.STRIPE_HIDE_POSTAL_CODE;
    return (
        <Fragment>
            <label className={'blue small mb-0 isRequired'}>{translate('Card number')}</label>
            <CardNumberElement onChange={event => onCardChange(event, 'number')} />
            <div className={'row'}>
                <div className={'col'}>
                    <label className={'blue small  mt-3 mb-0 isRequired'}>{translate('Expiry date')}</label>
                    <CardExpiryElement onChange={event => onCardChange(event, 'expiryDate')} />
                </div>
                <div className={'col'}>
                    <label className={'blue small mt-3 mb-0 isRequired'}>{translate('CVC')}</label>
                    <CardCvcElement onChange={event => onCardChange(event, 'cvc')} />
                </div>
            </div>
            {!hidePostalCode && (
                <div className={'row'}>
                    <div className={'col'}>
                        <label className={'blue small mt-3 mb-0 isRequired'}>{translate('Postal code')}</label>
                        <input
                            type="text"
                            name="postalCode"
                            className="form-control"
                            id={'postalCode'}
                            placeholder={translate('Zip Code')}
                            onChange={e => setPostalCode(e.target.value)}
                        />
                    </div>
                </div>
            )}
        </Fragment>
    );
}

export default CardSection;
